import {
    TransferPartner,
    TransferProduct,
    TransferVehicle,
} from '@/api/Cart/cart.interfaces';
import {
    TransferOption,
    TransferOptionPartner,
    TransferOptionVehicle,
} from '@/api/Transfer/transfer.interfaces';

interface TransferDescriptionData {
    TransferVehicle: TransferOptionVehicle;
    TransferPartner: TransferOptionPartner;
    MaxLargeLuggage: number | null;
    Duration: number | null;
    FreeCancelUntil: Date | null;
}

export function isTransferProduct(
    data: TransferProduct | TransferOption
): data is TransferProduct {
    return !!(data as TransferProduct).OfferId;
}

export const mapDescription = (
    data: TransferProduct | TransferOption
): TransferDescriptionData => {
    return isTransferProduct(data) ? mapTransferProduct(data) : data;
};

const mapTransferProduct = (product: TransferProduct): TransferDescriptionData => {
    const mapVehicle = (v: TransferVehicle): TransferOptionVehicle => ({
        ...v,
        CategoryType: v.TransferCategory,
    });

    const mapPartner = (p: TransferPartner): TransferOptionPartner => ({
        ...p,
        Logo: p.Image,
    });

    return {
        Duration: product.Duration,
        FreeCancelUntil: product.FreeCancelUntil,
        MaxLargeLuggage: product.Luggage,
        TransferVehicle: mapVehicle(product.Vehicle),
        TransferPartner: mapPartner(product.Partner),
    };
};
